import Header from "@/components/Header";
import Footer from "@/components/Footer";

export const PageShell = ({ children }) => (
  <>
    <Header />
    <main className="max-w-md mx-auto sm:max-w-2xl lg:max-w-4xl px-4 sm:px-6 py-6">
      {children}
    </main>
    <Footer />
  </>
);

export default PageShell;
